import {
    Component,
    Input,
    OnInit,
    OnDestroy,
    SimpleChanges,
    OnChanges,
    ViewChild,
    ElementRef,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { NumberUtil } from '../../../../infra/number-util';
import { ToastrService } from 'ngx-toastr';
import { SaldoService } from '../../../../services/saldo.service';
import { FiltroSegmentacao } from '../../../../interfaces/segmentacao/filtro-segmentacao.interface';
import { NovaListaContato } from '../../../../interfaces/lista-contato/lista-contato.interface';
import { Saldo } from '../../../../interfaces/saldo/saldo.interface';
import { ListasService } from '../../../../services/listas.service';
import { FiltroSegmentacaoService } from '../../../../state-service/filtro-segmentacao.service';
import { Subscription } from 'rxjs';
import { EnumPermissao } from '../../../../enums/permissoes.enum';
import { PermissaoService } from '../../../../services/permissao.service';
import tippy, { Instance as TippyInstance } from 'tippy.js';
declare var bootstrap: any;

registerLocaleData(localePt);

@Component({
    selector: 'app-modal-lista-contato',
    templateUrl: './modal-lista-contato.component.html',
    styleUrls: ['./modal-lista-contato.component.css'],
    standalone: false,
})
export class ModalListaContatoComponent
    implements OnInit, OnDestroy, OnChanges {
    EnumPermissao = EnumPermissao;
    private subscription: Subscription = new Subscription();
    private modalElement: any;
    private bsModal: any;
    @Input() qtdRegistros: number = 0;
    @Input() filtro: FiltroSegmentacao | undefined;
    @Input() continuarExtracao: boolean = false;

    novaListaContato: NovaListaContato = {
        nomeLista: '',
        qtdeExtracao: this.qtdRegistros,
        filtro: undefined,
        continuarExtracao: this.continuarExtracao,
    };

    saldoRestante: number = 0;
    saldo: Saldo = {
        quantidade: 0,
        motivo: 0,
        mensagemMotivoSaldo: '',
        tipo: '',
    };
    mostrarCreditosFaltantes: boolean = false;
    mostrarSaldoCreditos: boolean = false;
    saldoFaltante: number = 0;
    podeExtrairContatos: boolean = false;
    msgTooltipBtnSalvar: string = 'Salvar lista de contatos';
    processando: boolean = false;
    mostrarBotaoRecarga: boolean = false;
    podeFazerRecarga: boolean = false;

    @ViewChild('nomeInput') nomeInput: ElementRef | undefined;
    @ViewChild('qtdInput') qtdInput: ElementRef | undefined;

    private nomeTooltip: any;
    private qtdTooltip: any;

    constructor(
        private toastr: ToastrService,
        private saldoService: SaldoService,
        private listasService: ListasService,
        private filtroSegmentacaoService: FiltroSegmentacaoService,
        public permissaoService: PermissaoService
    ) { }

    ngOnInit() {
        this.modalElement = document.getElementById('modalGerarListaContatos');
        if (this.modalElement) {
            this.bsModal = new bootstrap.Modal(this.modalElement);

            this.modalElement.addEventListener('show.bs.modal', async () => {
                await this.inicializarModal();
            });

            this.modalElement.addEventListener('hide.bs.modal', () => {
                this.destruirTooltips();
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['qtdRegistros'] && !changes['qtdRegistros'].firstChange) {
            this.validarListaContatos();
        }

        if (changes['continuarExtracao']) {
            this.novaListaContato.continuarExtracao = this.continuarExtracao;
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        
        this.destruirTooltips();
        
        if (this.modalElement) {
            this.modalElement.removeEventListener(
                'show.bs.modal',
                this.inicializarModal
            );
            this.modalElement.removeEventListener(
                'hide.bs.modal',
                this.cancelarListaContato
            );
            if (this.bsModal) {
                this.bsModal.dispose();
            }
        }
    }

    async inicializarModal() {
        try {
            this.saldoService.getSaldoObservable().subscribe((saldo) => {
                this.saldo = saldo;
                this.saldoRestante = this.saldo.quantidade;
                this.podeFazerRecarga = this.saldo.tipo !== 'LIMITE';
                this.calcularSaldoRestante();
                this.calcularSaldoFaltante();
                this.validarListaContatos();
            });

            this.novaListaContato.continuarExtracao = this.continuarExtracao;

            this.novaListaContato.filtro =
                this.filtroSegmentacaoService.obterFiltroAtual();

            setTimeout(() => {
                this.inicializarTooltips();
            }, 100);
        } catch (error) {
            console.error('Erro ao inicializar modal:', error);
        }
    }

    inicializarTooltips(): void {
        if (this.nomeInput) {
            this.nomeTooltip = tippy(this.nomeInput.nativeElement, {
                content: 'Nome da lista não pode ser vazio',
                theme: 'dark',
                placement: 'right',
                trigger: 'manual',
                arrow: true,
                offset: [0, 10],
                appendTo: document.body,
            });
        }

        if (this.qtdInput) {
            this.qtdTooltip = tippy(this.qtdInput.nativeElement, {
                content: 'Quantidade inválida',
                theme: 'dark',
                placement: 'right',
                trigger: 'manual',
                arrow: true,
                offset: [0, 10],
                appendTo: document.body,
            });
        }
    }

    calcularSaldoRestante() {
        const saldoRestante =
            this.saldo.quantidade - this.novaListaContato.qtdeExtracao;
        if (saldoRestante < 0) {
            this.saldoRestante = 0;
        } else {
            this.saldoRestante = saldoRestante;
        }
    }

    calcularSaldoFaltante() {
        const creditosNecessarios = this.novaListaContato.qtdeExtracao;
        if (creditosNecessarios > this.saldo.quantidade) {
            this.saldoFaltante = creditosNecessarios - this.saldo.quantidade;
            this.mostrarCreditosFaltantes = true;
            this.mostrarSaldoCreditos = false;
            this.mostrarBotaoRecarga = this.permissaoService.hasPermission(
                EnumPermissao.FazerRecarga
            );
        } else {
            this.saldoFaltante = 0;
            this.mostrarCreditosFaltantes = false;
            this.mostrarSaldoCreditos = true;
            this.mostrarBotaoRecarga = false;
        }
        return this.saldoFaltante;
    }

    onChangeNomeLista(event: any) {
        this.esconderTooltipNome();
        this.esconderTooltipQuantidade();
    }

    onNumeroContatosChange(event: any) {
        this.esconderTooltipNome();
        this.esconderTooltipQuantidade();

        const input = event.target.value.replace(/\D/g, '');
        let quantidade = parseInt(input, 10) || 0;

        if (quantidade <= 0) {
            quantidade = 0;
            event.target.value = '';
            this.novaListaContato.qtdeExtracao = 0;
        } else if (quantidade > this.qtdRegistros) {
            quantidade = this.qtdRegistros;
            event.target.value = this.qtdRegistros.toString();
            this.novaListaContato.qtdeExtracao = this.qtdRegistros;
        } else {
            this.novaListaContato.qtdeExtracao = quantidade;
            event.target.value = quantidade.toString();
        }

        this.calcularSaldoFaltante();
        this.calcularSaldoRestante();
        this.validarListaContatos();
    }

    exibirTooltipNome(texto: string) {
        if (this.nomeTooltip) {
            this.nomeTooltip.setContent(texto);
            this.nomeTooltip.show();
        }
    }

    esconderTooltipNome() {
        if (this.nomeTooltip) {
            this.nomeTooltip.hide();
        }
    }

    exibirTooltipQuantidade(texto: string) {
        if (this.qtdTooltip) {
            this.qtdTooltip.setContent(texto);
            this.qtdTooltip.show();
        }
    }

    esconderTooltipQuantidade() {
        if (this.qtdTooltip) {
            this.qtdTooltip.hide();
        }
    }

    destruirTooltips() {
        if (this.nomeTooltip) {
            this.nomeTooltip.destroy();
            this.nomeTooltip = null;
        }
        if (this.qtdTooltip) {
            this.qtdTooltip.destroy();
            this.qtdTooltip = null;
        }
    }

    validarListaContatos(exibirMensagens: boolean = false): boolean {
        const nomeValido = this.novaListaContato.nomeLista?.trim()?.length > 0;
        const qtdValida =
            this.novaListaContato.qtdeExtracao > 0 &&
            this.novaListaContato.qtdeExtracao <= this.qtdRegistros;

        if (!nomeValido) {
            this.exibirTooltipNome('Nome da lista não pode ser vazio');
        } else {
            this.esconderTooltipNome();
        }

        if (
            this.novaListaContato.qtdeExtracao !== null &&
            this.novaListaContato.qtdeExtracao !== undefined &&
            !qtdValida
        ) {
            this.exibirTooltipQuantidade(
                this.novaListaContato.qtdeExtracao <= 0
                    ? 'Quantidade deve ser maior que zero'
                    : 'Quantidade excede o limite disponível'
            );
        } else {
            this.esconderTooltipQuantidade();
        }

        return nomeValido && qtdValida;
    }

    async gerarListaContato() {
        if (
            !this.permissaoService.hasPermission(EnumPermissao.GerarListaContatos)
        ) {
            this.toastr.warning(
                'Você não tem permissão para gerar lista de contatos',
                'Atenção'
            );
            return;
        }

        if (!this.validarListaContatos(true)) {
            return;
        }

        this.processando = true;
        try {
            await this.listasService.gerarListaContato(this.novaListaContato);
            this.toastr.success('Lista de contatos gerada com sucesso', 'Sucesso');
            
            this.destruirTooltips();
            
            const modalElement = document.getElementById('modalGerarListaContatos');
            const modal = bootstrap.Modal.getInstance(modalElement);
            modal.hide();
            this.limparModal();
        } catch (error) {
            this.toastr.error('Erro ao gerar lista de contatos', 'Erro');
        } finally {
            this.processando = false;
            this.saldoService.obterSaldo();
        }
    }

    cancelarListaContato() {
        this.destruirTooltips();
        this.limparModal();
    }

    limparModal() {
        this.mostrarCreditosFaltantes = false;
        this.mostrarSaldoCreditos = true;
        this.novaListaContato.qtdeExtracao = 0;
        this.saldoFaltante = 0;
        this.saldoRestante = 0;
        this.podeExtrairContatos = false;
        this.novaListaContato.nomeLista = '';
        this.mostrarBotaoRecarga = false;
    }

    async atualizarSaldo() {
        try {
            this.saldo = await this.saldoService.obterSaldoAtual();
            this.saldoRestante = this.saldo.quantidade;
            this.calcularSaldoRestante();
            this.validarListaContatos();
        } catch (error) {
            console.error(
                'Erro ao atualizar saldo no modal de lista de contatos:',
                error
            );
        }
    }
}
